import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { provideParentFormGroup } from '@platform/components/forms/forms.utils';
import { distinctUntilChanged } from 'rxjs';
import { RootState } from '@root/app.state';
import { Store } from '@ngrx/store';
import { selectNavigatedCustomerSpaceName } from '@core/core.selectors';
import { PreComponent } from '@platform/components/pre/pre.component';
import { ShortenPipe } from '@platform/shared/shorten.pipe';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-form-toggle-filter-users-by-customer-space',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    ShortenPipe,
    PreComponent,
  ],
  templateUrl: './form-toggle-filter-users-by-customer-space.component.html',
  styleUrls: ['./form-toggle-filter-users-by-customer-space.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideParentFormGroup()],
})
export class FormToggleFilterUsersByCustomerSpaceComponent {
  @Output() filterChanged = new EventEmitter<boolean>();
  customerSpaceName$ = this.store$.select(selectNavigatedCustomerSpaceName);
  control = new FormControl(true);

  constructor(private store$: Store<RootState>) {
    this.control.valueChanges.pipe(distinctUntilChanged(), takeUntilDestroyed()).subscribe((value) => {
      this.filterChanged.emit(Boolean(value));
    });
  }

  @Input()
  set isByCustomerSpace(value: boolean) {
    this.control.setValue(value);
  }
}
